let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("99t4P")).then(() => parcelRequire('aCDtt'));